const SvgIconMail = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M0 5.359V14h16V5.358l-8 5-8-5Z" />
    <path fill="currentColor" d="M16 3V2H0v1l8 5 8-5Z" />
  </svg>
)
export default SvgIconMail
